import audios0 from "./tracks/beach-track.mp3";
import audios1 from "./tracks/rain-track.mp3";
import audios2 from "./tracks/fire-track.mp3";
import audios3 from "./tracks/coding-track.mp3";
import audios4 from "./tracks/meditative-track.mp3";
import audios5 from "./tracks/forest-track.mp3";
import audios6 from "./tracks/bollywood-track.mp3";

const tracks = document.querySelectorAll(".track");
const audios = document.querySelectorAll(".audio");
const volumeSlider = document.querySelector("#volume-slider");

// running a for loop and adding an eventlistener on each one of the tracks
tracks.forEach((track, index) => {
  track.addEventListener("click", () => {
    //condition for checking if the audio is paused
    if (audios[index].paused) {
      audios[index].play(); //play audio
      track.classList.add("active"); //add active class
      track.classList.add("animate-songClick"); //add animation
      // volumeSlider.classList.toggle("hidden");
    } else {
      audios[index].pause();
      track.classList.remove("active");
      track.classList.remove("animate-songClick");
      // volumeSlider.classList.toggle("hidden");
    }
  });
});

volumeSlider.addEventListener("input", () => {
  audios.forEach((audio) => {
    audio.volume = volumeSlider.value;
  });
});

//Todo-list
